module.exports = __webpack_public_path__ + "ve.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ve.svg
// module id = 1132
// module chunks = 0